export default "__VITE_ASSET__BTFynUPs__"